export const navData = [
  {
    id: 0,
    title: '交互原型',
    data: [
      {
        outSite: true,
        url: 'https://modao.cc/proto/hJck9QBus2z6edcbxlDkFR/sharing?view_mode=device&screen=rbpTtV5OZg8bWf9pb&canvasId=rcTtV5OZojlSBHjs',
        name: '商栈PC端原型',
      },
      {
        outSite: true,
        // url: 'https://modao.cc/app/fb80ee3f4b8d7df198fe1a19ac837572c9efa4fa',  //tjh的原型
        //url: 'https://modao.cc/app/vPtI2nLirucazh8JRcKu3L#screen=sl9qvyacog0lhett501ntch7o',//董工复制出来的原型
        url: 'https://modao.cc/proto/JO691BP6s2v6klNRI94eCg/sharing?view_mode=device&screen=sle6lauzTtISsGIdUeCvlH&canvasId=ssle50mmTtIStZNvmSskL4&from=sharing',//V8原型
        name: '商栈小程序原型',
      },
      {
        outSite: true,
        url: 'https://modao.cc/proto/dF9Cf0o2sb97lgjSc2yM5t/sharing?view_mode=device&screen=sllyla74U8gCZOes6lWboq&canvasId=ssllyla7U8gCZOfUdxqhz6',
        name: '商栈小程序裂变导航',
      },
      {
        outSite: true,
        url: 'https://modao.cc/app/JYTSCgmMrxrob5MmwO9PL',
        name: '演示环境原型',
      },
      {
        outSite: true,
        url: 'https://sz-demo.yuneop.com/#/policy',
        name: '代理政策原型',
      },

      {
        outSite: true,
        url: 'https://modao.cc/app/2wop94vrm7eaptYAj8aaC#screen=sldmvrpl1t4lefgjzrmpx40a6',
        name: '商栈PC端原型-dg版',
      },
      {
        outSite: true,
        url: 'https://modao.cc/app/FyacwEor6z3h9KHkBdzcD',
        name: '商栈PC端原型-tg版',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/qyxtpt',
        name: '商栈PC端原型-tgAxure版',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/%E7%89%88%E6%9C%AC%E7%AE%A1%E7%90%86.html',
        name: '版本管理',
      }
      ,
      {
        outSite: true,
        url: 'https://modao.cc/app/wlkKJgKmsivbqzsgAUcI',
        name: '商栈移动前端UI',
      }
    ]
  },
  {
    id: 1,
    title: '推广链接',
    desc: '注：平台注册的流程与邀请供应商/客户的流程一样的，区别在于，推广链接引导的只是注册登录平台。',
    data: [
      {
        outSite: true,
        url: 'https://modao.cc/app/2wop94vrm7eaptYAj8aaC#screen=sldy9xz3rf7lefgjzsfj55ioe',
        name: '【推广链接】原型-PC',
      },
      {
        outSite: true,
        url: 'https://modao.cc/app/fb80ee3f4b8d7df198fe1a19ac837572c9efa4fa#screen=sl5th6q4295kyfj',
        name: '【推广链接】原型-小程序',
      },
      {
        outSite: true,
        url: 'https://modao.cc/app/fb80ee3f4b8d7df198fe1a19ac837572c9efa4fa#screen=slj5s1wsv3xt2eg',
        name: '受邀方打开链接原型',
        desc: '受邀方打开链接后的界面（引导注册、登录、此种方式注册商栈平台后，自动拥有企业体验账号）H5打开页面后原型',
      },
      {
        outSite: true,
        url: 'https://modao.cc/app/fb80ee3f4b8d7df198fe1a19ac837572c9efa4fa#screen=slj9okecr4565ki',
        name: '注册成功原型',
        desc: '注册成功后页面原型',
      }, {
        outSite: true,
        url: ' https://modao.cc/proto/YVGc1LdIrx1mmlvzqtQHQH/sharing?view_mode=read_only ',
        name: 'P.R.M',
        desc: 'PRM(侯欢欢)',
      },
      // {
      //   outSite: true,
      //   url: ' https://modao.cc/app/2wop94vrm7eaptYAj8aaC#screen=sldmvrpl1t4lefgjzrmpx40a6',
      //   name: '企业协同平台（董）',
      //   //desc: '注册成功后页面原型',
      // },


    ]
  },
  {
    id: 1,
    title: '奔云内部系统-lan',
    data: [
      {
        outSite: true,
        url: 'http://erp.yuneop.com',
        name: '商栈企业协同平台[测试]',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:89',
        name: '禅道',
      },
      {
        outSite: true,
        url: 'http://192.168.0.177:8081',
        name: '自动化测试平台',
      },
      {
        outSite: true,
        url: 'http://lantest01.yuneop.com:5200/doc.html',
        name: '接口文档',
      },
      {
        outSite: true,
        url: 'http://192.168.0.75:8000',
        name: 'Jenkins',
      }, {
        outSite: true,
        url: 'http://192.168.0.75:3000',
        name: 'gita',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:8848/nacos',
        name: 'nacos',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:9080',
        name: 'skywalking',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:8898/',
        name: 'sentinel',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:9993',
        name: 'Rocket MQ',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:8089/xxl-job-admin',
        name: 'xx-job',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:9083',
        name: 'nexus',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:9000',
        name: 'portainer81-middleware',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:8081',
        name: 'Flink',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:9200',
        name: 'ElastSearch',
      },
      {
        outSite: true,
        url: 'http://192.168.0.81:5601',
        name: 'Kibana',
      }
    ]
  },
  {
    id: 2,
    title: '奔云内部系统-外部访问',
    data: [
      {
        outSite: true,
        url: 'http://erp.yuneop.com',
        name: '商栈企业协同平台[测试]',
      },
      {
        outSite: true,
        url: 'http://admin.yuneop.com',
        name: '商栈企业平台-后台管理[测试]',
      },
      {
        outSite: true,
        url: 'http://chandao.yuneop.com',
        name: '禅道',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:5200/doc.html',
        name: '接口文档-测试',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:18000',
        name: 'Jenkins',
      }, {
        outSite: true,
        url: 'http://test.yuneop.com:3000',
        name: 'git',
      }, {
        outSite: true,
        url: 'http://test.yuneop.com:18848/nacos',
        name: 'nacos 18848',
      }, {
        outSite: true,
        url: 'http://test.yuneop.com:9083',
        name: 'nexus',
      }, {
        outSite: true,
        url: 'http://test.yuneop.com:19993',
        name: 'Rocket MQ',
      }, {
        outSite: true,
        url: 'http://test.yuneop.com:8089/xxl-job-admin',
        name: 'XX-JOB',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:9981',
        name: '自动化测试平台',
      },
      {
        outSite: true,
        url: '#',
        name: 'redis 10002',
      }, {
        outSite: true,
        url: '#',
        name: 'mysql-test 9967',
      }, {
        outSite: true,
        url: '#',
        name: 'mysql-tools 9968',
      },
      {
        outSite: true,
        url: 'http://chuantou.yuneop.com/',
        name: 'LanProxy',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:9995',
        name: 'Flink',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:9991',
        name: 'ElastSearch',
      },
      {
        outSite: true,
        url: 'http://test.yuneop.com:9992',
        name: 'Kibana',
      }

    ]
  },
  {
    id: 3,
    title: '预生产系统',
    data: [
      {
        outSite: true,
        url: 'https://erp.gray.yuneop.com',
        name: '商栈云平台-预生产环境',
      }, {
        outSite: true,
        url: 'http://47.103.47.103:9200',
        name: 'ElastSearch',
      }, {
        outSite: true,
        url: 'http://47.103.47.103:5601',
        name: 'Kibana',
      }, {
        outSite: true,
        url: 'http://47.103.47.103:9800',
        name: 'Portainer',
      },
    ]
  },
  {
    id: 4,
    title: '正式系统',
    data: [
      {
        outSite: true,
        url: 'https://erp.shangzhanyun.com',
        name: '商栈云平台-生产环境',
      },
      {
        outSite: true,
        url: 'http://szadmin.shangzhanyun.com',
        name: '后台管理-生产环境',
      },
      {
        outSite: true,
        url: 'https://www.shangzhanyun.com',
        name: '官网',
      },
      {
        outSite: true,
        url: 'http://8.153.73.43:9081/',
        name: 'skywalking',
      },
      {
        outSite: true,
        url: 'http://8.153.73.43:9200',
        name: 'ElastSearch',
      }, {
        outSite: true,
        url: 'http://8.153.73.43:5601',
        name: 'Kibana',
      }, {
        outSite: true,
        url: 'http://8.153.73.43:9800',
        name: 'Portainer',
      },
    ]
  },
  {
    id: 4,
    title: '体验版',
    data: [
      {
        outSite: true,
        url: 'https://erp.demo.shangzhanyun.cn',
        name: '商栈云平台-体验版',
      }
    ]
  },
  {
    id: 5,
    title: '归档',
    data: [
      {
        outSite: true,
        url: 'https://prototype.yuneop.com/CRM_V1.0_1205',
        name: '【CRM-HHH】',
      },
      {
        outSite: true,
        url: 'https://modao.cc/flow/Dzs2BhrfbffzinQ1rdwp',
        name: '【小程序流程图】',
      },
      {
        outSite: true,
        url: 'https://modao.cc/flow/jgO6NlDrrmkgwshCKO1Id',
        name: '【流程图-协同逻辑】',
      },
      {
        outSite: true,
        url: 'https://modao.cc/flow/77LD0darau2chTPwnIe12',
        name: '【H5流程图】',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/dg-demo/index.html?id=' + (new Date().getTime()),
        name: 'DG-平台原型',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/dg-websize-demo/网站首页_1.html?id=' + (new Date().getTime()),
        name: 'DG-网站原型',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/flow/取消协同业务逻辑.html?id=' + (new Date().getTime()),
        name: '取消协同业务逻辑',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/flow/2022B版订单收付款单协同业务逻辑.html?id=' + (new Date().getTime()),
        name: '2022版订单收付款单协同业务逻辑',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/flow/2022B版收发货协同业务逻辑.html?id=' + (new Date().getTime()),
        name: '2022B版收发货协同业务逻辑',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/flow/2022B版对账协同业务逻辑.html?id=' + (new Date().getTime()),
        name: '2022版对账协同业务逻辑',
      },
      {
        outSite: false,
        url: 'page1',
        name: '收发货交互原型',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/%E6%94%B6%E5%8F%91%E8%B4%A7%E5%8D%95%E5%8D%8F%E5%90%8C%E5%8E%9F%E5%9E%8B2021-11-26/#id=cxppdf&p=%E9%80%81%E8%B4%A7%E5%8D%95-%E9%94%80%E5%94%AE%E6%96%B9&g=1',
        name: '收发货单协同原型2021-11-26',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/dg-0425/',
        name: 'DG：2022-04-25',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/qudao',
        name: '企业协同平台结构原型-DG-qudao',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/dg-0915',
        name: '企业协同平台结构原型-DG-0915',
      },
      {
        outSite: true,
        url: 'http://prototype.yuneop.com/yunerp',
        name: '商栈供应链原型（旧）',
      },
      {
        outSite: true,
        url: 'https://93aidi.axshare.com',
        name: '奔云产品功能架构图(旧)',
      },
      {
        outSite: true,
        url: 'https://org.modao.cc/app/198d8de73d08944d74fa3990ff23e4dac481dc68?simulator_type=outside_artboard&sticky#screen=skd72xehbsbgtta',
        name: '墨刀PC-企业中心(旧)',
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/navData.js